import React, { Component } from 'react';

import './index.css';
class FilePicker extends Component {
  constructor() {
    super();

    this.state = {
      text: 'Select a file to upload (.zip)',
      showError: false
    }

    this.file = null;

    this.buttonClickHandler = this.buttonClickHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  render() {
    return (
      <div className={this.state.showError ? 'file_picker_wrapper error' : 'file_picker_wrapper'}>

        <div className="aligner"></div>

        <div className="text">
          {this.state.text}
        </div>

        <div className="button" onClick={this.buttonClickHandler}>Select File</div>

        <input ref={(el) => this.file = el} type="file" onChange={this.onChangeHandler} style={{ display: 'none' }} />

      </div>
    );
  }

  buttonClickHandler() {
    this.file.click();
  }

  onChangeHandler(e) {
    let file = e.target.files[0];

    let fileName = file.name;

    let zipRegex = /.*.zip$/;

    if (!zipRegex.test(fileName)) {
      e.target.value = null;
      this.setState({
        text: 'Please upload a valid .zip file',
        showError: true
      });

      if (this.props.onChange) {
        this.props.onChange(null);
      }

      return;
    }

    this.setState({
      text: fileName,
      showError: false
    });

    if (this.props.onChange) {
      this.props.onChange({
        fileName: fileName,
        file: file
      });
    }

  }
}

export default FilePicker;


// WEBPACK FOOTER //
// ./src/components/FilePicker/index.js